import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html } from "lit";
import "../../atom/Row/index.js";
import "../../atom/Column/index.js";
import "../../atom/Text/index.js";
import { when } from "lit-html/directives/when.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfDisplayText = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_size = "medium";
  }
  render() {
    const icon = when(
      this.dsf_icon,
      () => html`<dsf-icon dsf_name=${this.dsf_icon} class="h-16 w-16"></dsf-icon>`
    );
    return html`
      <dsf-row dsf_gap="s">
        ${icon}
        <dsf-col dsf_gap="xs">
          <dsf-text
            dsf_level=${this.dsf_size === "medium" ? "xs" : "xxs"}
            dsf_color_intensity="400"
          >
            ${this.dsf_label}
          </dsf-text>
          <slot></slot>
        </dsf-col>
      </dsf-row>
    `;
  }
};
__decorateClass([
  prop({ type: String, reflect: true })
], DsfDisplayText.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: String })
], DsfDisplayText.prototype, "dsf_label", 2);
__decorateClass([
  prop({ type: String })
], DsfDisplayText.prototype, "dsf_icon", 2);
DsfDisplayText = __decorateClass([
  defineElement("dsf-display-text")
], DsfDisplayText);
export {
  DsfDisplayText
};
